import React from 'react';

const ProtectedRoute = ({ children }) => {
  // Date selection is not required for navigation; dates are used when sending WhatsApp messages.
  return children;
};

export default ProtectedRoute;



